// extracted by mini-css-extract-plugin
export default {"gridContainer":"NonMobileCarouser_gridContainer__BqL0u","grid":"NonMobileCarouser_grid__rEG7Z"};